export default "__VITE_ASSET__C_hLd1EL__ 400w, __VITE_ASSET__DL2B3ESm__ 800w, __VITE_ASSET__7de$eyOr__ 1024w";